/* =============================================================
   Provenzano Mayorista — Catálogo "Armá tu pedido"
   assets/pv-catalog.js
   Fetches products from Shopify /products.json, handles
   filtering, cart (Shopify AJAX), and WhatsApp checkout.
   ============================================================= */

(function () {
  'use strict';

  /* ── Config injected from Liquid ─────────────────────────── */
  const CFG = window.PV_CATALOG_CFG || {
    whatsapp: '5491141794592',
    shopName: 'Provenzano Mayorista',
  };

  /* ── Shipping rules ─────────────────────────────────────── */
  const ZONES = [
    {
      id: 'caba',
      label: 'CABA (Capital Federal)',
      price: 4100,
      partidos: ['CABA (Capital Federal)'],
    },
    {
      id: 'gba1',
      label: 'GBA 1',
      price: 5000,
      partidos: [
        'Avellaneda', 'Lanús', 'Lomas de Zamora',
        'La Matanza Norte (San Justo, Ramos Mejía, Tapiales)',
        'Morón', 'Tres de Febrero', 'San Martín',
        'Vicente López', 'San Isidro',
      ],
    },
    {
      id: 'gba2',
      label: 'GBA 2',
      price: 6000,
      partidos: [
        'San Fernando', 'Tigre', 'Malvinas Argentinas',
        'José C. Paz', 'San Miguel', 'Hurlingham', 'Ituzaingó',
        'La Matanza Sur (Gregorio de Laferrere, González Catán, Virrey del Pino)',
        'Merlo', 'Moreno', 'Esteban Echeverría',
        'Almirante Brown', 'Ezeiza', 'Quilmes',
        'Florencio Varela', 'Berazategui',
      ],
    },
    {
      id: 'gba3',
      label: 'GBA 3',
      price: 7900,
      partidos: [
        'Zárate', 'Campana', 'Escobar', 'Ing. Maschwitz',
        'Garín', 'Pilar', 'Del Viso', 'Derqui', 'Villa Rosa',
        'Luján', 'Gral. Rodríguez', 'Marcos Paz', 'Nordelta',
        'San Vicente', 'Guernica', 'Berisso', 'La Plata',
        'Cañuelas', 'Ensenada',
      ],
    },
  ];

  const MODES = [
    {
      id: 'pickup',
      label: 'Retiro en sucursal',
      tag: 'Gratis',
      icon: 'store',
      sub: 'Carhué 74, Liniers · L-V 8:30 a 16 hs',
      min: 100000,
      cost: 0,
      freeFrom: null,
      fields: ['nombre'],
    },
    {
      id: 'cabagba',
      label: 'Envío CABA y GBA',
      tag: 'Mismo día',
      icon: 'truck',
      sub: 'Logística propia · gratis desde $600.000',
      min: 100000,
      cost: 'zone',
      freeFrom: 600000,
      fields: ['nombre', 'partido', 'direccion', 'telefono'],
    },
    {
      id: 'viacargo',
      label: 'Vía Cargo',
      tag: 'Despacho gratis',
      icon: 'package',
      sub: 'Flete a cargo del cliente al recibir',
      min: 200000,
      cost: 0,
      freeFrom: null,
      fields: ['nombre', 'dni', 'provincia', 'ciudad', 'sucursal_o_domicilio', 'telefono'],
    },
    {
      id: 'transporte',
      label: 'Tu transporte',
      tag: 'Pedidos grandes',
      icon: 'truck',
      sub: 'Sin costo al depósito del transporte',
      min: 500000,
      cost: 0,
      freeFrom: null,
      fields: ['nombre', 'dni', 'transporte', 'direccion_transporte', 'destino', 'telefono'],
    },
  ];

  /* ── State ──────────────────────────────────────────────── */
  const state = {
    products: [],
    cart: [],
    activeType: 'all',
    searchQuery: '',
    cartOpen: false,
    checkoutOpen: false,
    checkoutMode: 'pickup',
    checkoutSubmode: 'sucursal',
    checkoutPartido: '',
    checkoutForm: {},
  };

  /* ── Helpers ─────────────────────────────────────────────── */
  function fmt(amount) {
    return '$ ' + Math.round(amount).toLocaleString('es-AR');
  }

  function findZoneByPartido(partido) {
    return ZONES.find(z => z.partidos.includes(partido)) || null;
  }

  function calcShipping() {
    const m = MODES.find(m => m.id === state.checkoutMode);
    const subtotal = cartSubtotal();
    if (!m) return { cost: 0, free: false };
    if (m.cost === 0) return { cost: 0, free: false };
    if (m.cost === 'zone') {
      if (m.freeFrom && subtotal >= m.freeFrom) return { cost: 0, free: true };
      const zone = findZoneByPartido(state.checkoutPartido);
      return zone ? { cost: zone.price, free: false } : { cost: null, free: false };
    }
    return { cost: 0, free: false };
  }

  function cartSubtotal() {
    return state.cart.reduce((a, i) => a + i.price * i.qty, 0);
  }

  function cartCount() {
    return state.cart.reduce((a, i) => a + i.qty, 0);
  }

  function el(id) { return document.getElementById(id); }
  function qsa(selector, ctx) { return Array.from((ctx || document).querySelectorAll(selector)); }

  /* ── DOM refs (populated in init) ───────────────────────── */
  let $grid, $filterBar, $countRow, $cartBadge,
      $cartOverlay, $cartDrawer, $cartBody, $cartFoot, $cartTotal,
      $coOverlay, $coModeGrid, $coFields, $coPartidoWrap,
      $coSubtotalRow, $coShipRow, $coHint, $coTotalRow, $coSendBtn,
      $toast;

  /* ── Fetch all products (paginated) ─────────────────────── */
  async function fetchAllProducts() {
    let page = 1;
    let all = [];
    while (true) {
      const res = await fetch(`/products.json?limit=250&page=${page}`);
      if (!res.ok) break;
      const data = await res.json();
      if (!data.products || !data.products.length) break;
      all = all.concat(data.products);
      if (data.products.length < 250) break;
      page++;
    }
    return all;
  }

  /* ── Render filter chips ─────────────────────────────────── */
  function renderFilters(types) {
    if (!$filterBar) return;
    const allChip = $filterBar.querySelector('[data-type="all"]');
    qsa('[data-type]:not([data-type="all"])', $filterBar).forEach(c => c.remove());

    types.forEach(type => {
      const btn = document.createElement('button');
      btn.className = 'pv-chip';
      btn.dataset.type = type;
      btn.textContent = formatType(type);
      btn.addEventListener('click', () => setActiveType(type));
      $filterBar.appendChild(btn);
    });

    if (allChip) {
      allChip.addEventListener('click', () => setActiveType('all'));
    }
  }

  function formatType(type) {
    if (!type) return 'Varios';
    const labels = {
      'encendedores': 'Encendedores',
      'pilas': 'Pilas',
      'perfumeria': 'Perfumería',
      'pegamentos': 'Pegamentos',
      'afeitado': 'Afeitado',
      'repelentes': 'Repelentes',
      'golosinas': 'Golosinas',
      'farmacia': 'Farmacia',
      'higiene-personal': 'Higiene',
      'higiene personal': 'Higiene',
      'limpieza': 'Limpieza',
      'libreria': 'Librería',
      'librería': 'Librería',
      'merceria': 'Mercería',
      'mercería': 'Mercería',
      'naipes': 'Naipes',
      'electronica': 'Electrónica',
      'electrónica': 'Electrónica',
      'bebidas': 'Bebidas',
      'alimentos': 'Alimentos',
      'tabaqueria': 'Tabaquería',
      'tabaquería': 'Tabaquería',
      'preservativos': 'Preservativos',
      'bebes': 'Bebés',
      'bebés': 'Bebés',
    };
    return labels[type.toLowerCase()] || type.charAt(0).toUpperCase() + type.slice(1);
  }

  function setActiveType(type) {
    state.activeType = type;
    qsa('[data-type]', $filterBar).forEach(c => {
      c.classList.toggle('is-active', c.dataset.type === type);
    });
    applyFilters();
  }

  /* ── Render product grid ─────────────────────────────────── */
  function renderProducts(products) {
    if (!$grid) return;
    $grid.innerHTML = '';

    if (!products.length) {
      $grid.innerHTML = `
        <div class="pv-no-results">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
          <p>Sin resultados</p>
          <small>Probá con otra categoría o buscá por nombre.</small>
        </div>`;
      return;
    }

    products.forEach(p => {
      const card = buildProductCard(p);
      $grid.appendChild(card);
    });
  }

  function buildProductCard(p) {
    const price = parseFloat(p.variants[0]?.price || '0');
    const imgSrc = p.images[0]?.src || '';
    const type = p.product_type || '';
    const variantId = p.variants[0]?.id;

    const article = document.createElement('article');
    article.className = 'pv-pcard';
    article.dataset.productType = type.toLowerCase();
    article.dataset.productTitle = p.title.toLowerCase();

    article.innerHTML = `
      <div class="pv-pcard__img">
        ${imgSrc
          ? `<img src="${imgSrc}" alt="${escHtml(p.title)}" class="pv-pcard__photo" loading="lazy">`
          : `<svg class="pv-pcard__placeholder" viewBox="0 0 40 40" fill="none"><rect x="8" y="8" width="24" height="24" rx="4" stroke="currentColor" stroke-width="1.5" stroke-dasharray="3 3"/><path d="M16 20h8M20 16v8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>`}
      </div>
      <div class="pv-pcard__body">
        ${type ? `<span class="pv-pcard__cat">${escHtml(formatType(type))}</span>` : ''}
        <h3 class="pv-pcard__name">${escHtml(p.title)}</h3>
      </div>
      <div class="pv-pcard__bottom">
        <div class="pv-pcard__price-block">
          <span class="pv-pcard__price-label">Mayorista</span>
          <span class="pv-pcard__price">${fmt(price)}</span>
          <span class="pv-pcard__price-unit">por unidad</span>
        </div>
        <button class="pv-pcard__add" aria-label="Sumar ${escHtml(p.title)}" data-variant="${variantId}">
          ${iconPlus()}
        </button>
      </div>`;

    article.querySelector('.pv-pcard__add').addEventListener('click', (e) => {
      e.stopPropagation();
      addToCart({
        variantId,
        productId: p.id,
        title: p.title,
        type: formatType(type),
        price,
        image: imgSrc,
        qty: 1,
      });
    });

    return article;
  }

  /* ── Filtering ───────────────────────────────────────────── */
  function applyFilters() {
    const type = state.activeType;
    const q = state.searchQuery.toLowerCase().trim();
    const cards = qsa('.pv-pcard', $grid);
    let visible = 0;

    cards.forEach(card => {
      const matchType = type === 'all' || card.dataset.productType === type.toLowerCase();
      const matchSearch = !q || card.dataset.productTitle.includes(q);
      const show = matchType && matchSearch;
      card.classList.toggle('is-hidden', !show);
      if (show) visible++;
    });

    if ($countRow) {
      $countRow.textContent = `${visible} producto${visible !== 1 ? 's' : ''} disponibles`;
    }

    const noResults = $grid.querySelector('.pv-no-results');
    if (noResults) noResults.remove();
    if (visible === 0 && state.products.length > 0) {
      const div = document.createElement('div');
      div.className = 'pv-no-results';
      div.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
        <p>Sin resultados</p>
        <small>Probá con otra categoría o buscá por nombre.</small>`;
      $grid.appendChild(div);
    }
  }

  /* ── Cart ────────────────────────────────────────────────── */
  function addToCart(item) {
    const existing = state.cart.find(i => i.variantId === item.variantId);
    if (existing) {
      existing.qty += item.qty;
    } else {
      state.cart.push({ ...item });
    }
    renderCart();
    showToast(`Sumado: ${item.title}`);
    updateCartBadge();
  }

  function removeFromCart(variantId) {
    state.cart = state.cart.filter(i => i.variantId !== variantId);
    renderCart();
    updateCartBadge();
  }

  function setCartQty(variantId, qty) {
    const item = state.cart.find(i => i.variantId === variantId);
    if (item) {
      if (qty < 1) { removeFromCart(variantId); return; }
      item.qty = qty;
    }
    renderCart();
    updateCartBadge();
  }

  function updateCartBadge() {
    if (!$cartBadge) return;
    const count = cartCount();
    $cartBadge.textContent = count;
    $cartBadge.classList.toggle('has-items', count > 0);
  }

  function openCart() {
    state.cartOpen = true;
    $cartDrawer.classList.add('is-open');
    $cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    state.cartOpen = false;
    $cartDrawer.classList.remove('is-open');
    $cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderCart() {
    if (!$cartBody) return;
    const items = state.cart;

    if (!items.length) {
      $cartBody.innerHTML = `
        <div class="pv-cart__empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
          <p>Tu pedido está vacío</p>
          <small>Sumá productos del catálogo.</small>
        </div>`;
      if ($cartFoot) $cartFoot.style.display = 'none';
      return;
    }

    $cartBody.innerHTML = items.map(i => `
      <div class="pv-cartline" data-variant="${i.variantId}">
        <div class="pv-cartline__img">
          ${i.image
            ? `<img src="${i.image}" alt="">`
            : `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:40%;opacity:.5;color:var(--pv-primary)"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>`}
        </div>
        <div>
          <div class="pv-cartline__name">${escHtml(i.title)}</div>
          <div class="pv-cartline__cat">${escHtml(i.type)}</div>
          <div class="pv-cartline__row">
            <div class="pv-stepper pv-stepper--sm">
              <button onclick="PV_CATALOG.setQty('${i.variantId}', ${i.qty - 1})" aria-label="Restar">${iconMinus()}</button>
              <span>${i.qty}</span>
              <button onclick="PV_CATALOG.setQty('${i.variantId}', ${i.qty + 1})" aria-label="Sumar">${iconPlus()}</button>
            </div>
            <div class="pv-cartline__price">${fmt(i.price * i.qty)}</div>
          </div>
        </div>
        <button class="pv-cartline__rm" onclick="PV_CATALOG.removeItem('${i.variantId}')" aria-label="Quitar">
          ${iconTrash()}
        </button>
      </div>`).join('');

    if ($cartFoot) {
      const subtotal = cartSubtotal();
      $cartFoot.style.display = '';
      $cartFoot.innerHTML = `
        <div class="pv-cart__totalrow">
          <span>Subtotal</span>
          <span class="pv-cart__total">${fmt(subtotal)}</span>
        </div>
        <div class="pv-cart__note">El costo de envío se calcula en el siguiente paso.</div>
        <button class="pv-btn pv-btn--primary pv-btn--lg pv-cart__cta" onclick="PV_CATALOG.openCheckout()">
          Continuar ${iconArrowRight()}
        </button>`;
    }
  }

  /* ── Checkout sheet ──────────────────────────────────────── */
  function openCheckout() {
    closeCart();
    setTimeout(() => {
      state.checkoutOpen = true;
      renderCheckout();
      $coOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }, 120);
  }

  function closeCheckout() {
    state.checkoutOpen = false;
    $coOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderCheckout() {
    const subtotal = cartSubtotal();
    const activeMode = MODES.find(m => m.id === state.checkoutMode) || MODES[0];

    if ($coModeGrid) {
      $coModeGrid.innerHTML = MODES.map(m => {
        const active = m.id === state.checkoutMode;
        const meets = subtotal >= m.min;
        const missing = m.min - subtotal;
        return `
          <button class="pv-mode${active ? ' is-active' : ''}${!meets ? ' is-locked' : ''}"
                  onclick="PV_CATALOG.setCheckoutMode('${m.id}')">
            <div class="pv-mode__head">
              <span class="pv-mode__ic">${modeIcon(m.icon)}</span>
              <span class="pv-mode__title">${m.label}</span>
              ${m.tag ? `<span class="pv-mode__tag">${m.tag}</span>` : ''}
            </div>
            <div class="pv-mode__sub">${m.sub}</div>
            <div class="pv-mode__min">
              Mínimo ${fmt(m.min)}
              ${!meets ? `<span class="pv-mode__missing"> · te faltan ${fmt(missing)}</span>` : ''}
            </div>
          </button>`;
      }).join('');
    }

    const $viacargoSub = el('pv-co-submode');
    if ($viacargoSub) {
      $viacargoSub.style.display = state.checkoutMode === 'viacargo' ? '' : 'none';
      if (state.checkoutMode === 'viacargo') {
        $viacargoSub.querySelector('.pv-radio-row').innerHTML = [
          { id: 'sucursal', label: 'Sucursal Vía Cargo' },
          { id: 'domicilio', label: 'A domicilio' },
        ].map(s => `
          <button class="pv-radio-pill${state.checkoutSubmode === s.id ? ' is-active' : ''}"
                  onclick="PV_CATALOG.setCheckoutSubmode('${s.id}')">${s.label}</button>
        `).join('');
      }
    }

    renderCheckoutForm(activeMode);
    updateCheckoutSummary();
  }

  function renderCheckoutForm(mode) {
    if (!$coFields) return;
    const f = state.checkoutForm;
    const fields = mode.fields;
    let html = '';

    if (fields.includes('nombre')) html += field('nombre', 'Nombre y apellido', f.nombre, 'Ej: Juan Pérez');
    if (fields.includes('dni')) html += field('dni', 'DNI', f.dni, 'Sin puntos');
    if (fields.includes('partido')) html += partidoSelect();
    if (fields.includes('direccion')) html += field('direccion', 'Dirección de entrega', f.direccion, 'Calle, altura, piso/depto');
    if (fields.includes('provincia')) html += field('provincia', 'Provincia', f.provincia, 'Ej: Córdoba');
    if (fields.includes('ciudad')) html += field('ciudad', 'Ciudad', f.ciudad, 'Ej: Villa Carlos Paz');
    if (fields.includes('sucursal_o_domicilio')) {
      const isSuccursal = state.checkoutSubmode === 'sucursal';
      html += field('sucursal_o_domicilio',
        isSuccursal ? 'Sucursal Vía Cargo más cercana' : 'Dirección de entrega',
        f.sucursal_o_domicilio,
        isSuccursal ? 'Calle y altura de la sucursal' : 'Calle, altura, piso/depto');
    }
    if (fields.includes('transporte')) html += field('transporte', 'Nombre del transporte', f.transporte, 'Ej: Andesmar Cargas');
    if (fields.includes('direccion_transporte')) html += field('direccion_transporte', 'Dirección del transporte (CABA/GBA)', f.direccion_transporte, 'Calle y altura');
    if (fields.includes('destino')) html += field('destino', 'Ciudad y provincia destino', f.destino, 'Ej: Salta, Salta');
    if (fields.includes('telefono')) html += field('telefono', 'Teléfono / WhatsApp', f.telefono, 'Cód. área + número');
    html += field('nota', 'Nota para Provenzano (opcional)', f.nota, 'Aclaraciones, pedidos especiales…');

    $coFields.innerHTML = html;

    $coFields.querySelectorAll('[data-field]').forEach(input => {
      input.addEventListener('input', e => {
        state.checkoutForm[e.target.dataset.field] = e.target.value;
        updateCheckoutSummary();
      });
    });

    const $partido = el('pv-co-partido');
    if ($partido) {
      $partido.value = state.checkoutPartido;
      $partido.addEventListener('change', e => {
        state.checkoutPartido = e.target.value;
        updateCheckoutSummary();
      });
    }
  }

  function field(key, label, value, placeholder) {
    return `
      <div class="pv-field">
        <label class="pv-field__label">${label}</label>
        <input class="pv-field__input" type="text"
          data-field="${key}"
          value="${escHtml(value || '')}"
          placeholder="${escHtml(placeholder || '')}">
      </div>`;
  }

  function partidoSelect() {
    const options = ZONES.map(z => `
      <optgroup label="${z.label} — ${fmt(z.price)}">
        ${z.partidos.map(p => `<option value="${escHtml(p)}">${escHtml(p)}</option>`).join('')}
      </optgroup>`).join('');
    return `
      <div class="pv-field">
        <label class="pv-field__label">Partido / Localidad</label>
        <div class="pv-select-wrap">
          <select class="pv-field__select" id="pv-co-partido">
            <option value="">Elegí tu zona…</option>
            ${options}
          </select>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
        </div>
      </div>`;
  }

  function updateCheckoutSummary() {
    const subtotal = cartSubtotal();
    const ship = calcShipping();
    const total = subtotal + (ship.cost || 0);

    if (el('pv-co-subtotal')) el('pv-co-subtotal').textContent = fmt(subtotal);

    const $shipEl = el('pv-co-ship');
    if ($shipEl) {
      if (ship.free) {
        $shipEl.innerHTML = `<span class="pv-checkout__free">Gratis 🎉</span>`;
      } else if (ship.cost === 0) {
        $shipEl.textContent = 'Despacho gratis · flete a cargo del cliente';
      } else if (ship.cost === null) {
        $shipEl.innerHTML = `<span class="pv-checkout__warn">Elegí tu partido</span>`;
      } else {
        $shipEl.textContent = fmt(ship.cost);
      }
    }

    const $hint = el('pv-co-hint');
    if ($hint) {
      const mode = MODES.find(m => m.id === state.checkoutMode);
      if (ship.free && mode && mode.id === 'cabagba') {
        $hint.textContent = `🎉 Llegaste al envío gratis (desde ${fmt(mode.freeFrom)})`;
        $hint.style.display = '';
      } else {
        $hint.style.display = 'none';
      }
    }

    if (el('pv-co-total')) el('pv-co-total').textContent = fmt(total);

    const canSend = checkCanSend(subtotal);
    const $send = el('pv-co-send');
    if ($send) $send.disabled = !canSend;
  }

  function checkCanSend(subtotal) {
    const mode = MODES.find(m => m.id === state.checkoutMode);
    if (!mode || subtotal < mode.min) return false;
    const f = state.checkoutForm;
    const allFilled = mode.fields.every(field => {
      if (field === 'partido') return !!state.checkoutPartido;
      if (field === 'nota') return true;
      return (f[field] || '').trim().length > 0;
    });
    if (mode.id === 'cabagba' && !findZoneByPartido(state.checkoutPartido)) return false;
    return allFilled;
  }

  function buildWhatsAppMessage() {
    const items = state.cart;
    const subtotal = cartSubtotal();
    const ship = calcShipping();
    const total = subtotal + (ship.cost || 0);
    const today = new Date().toLocaleDateString('es-AR');
    const f = state.checkoutForm;
    const mode = MODES.find(m => m.id === state.checkoutMode);

    const lines = items.map(i =>
      `• ${i.qty}× ${i.title} — ${fmt(i.price)} c/u → ${fmt(i.price * i.qty)}`
    ).join('\n');

    let entrega = '';
    if (state.checkoutMode === 'pickup') {
      entrega = `📦 Retiro en sucursal (Carhué 74, Liniers)\n• Nombre: ${f.nombre}`;
    } else if (state.checkoutMode === 'cabagba') {
      const zone = findZoneByPartido(state.checkoutPartido);
      entrega = `🚚 Envío CABA/GBA — Zona ${zone ? zone.label : '—'}\n• Nombre: ${f.nombre}\n• Partido: ${state.checkoutPartido}\n• Dirección: ${f.direccion}\n• Tel: ${f.telefono}`;
    } else if (state.checkoutMode === 'viacargo') {
      const sub = state.checkoutSubmode === 'sucursal' ? 'Sucursal Vía Cargo' : 'A domicilio';
      entrega = `📮 Vía Cargo — ${sub}\n• Nombre: ${f.nombre}\n• DNI: ${f.dni}\n• ${f.provincia} / ${f.ciudad}\n• Entrega: ${f.sucursal_o_domicilio}\n• Tel: ${f.telefono}`;
    } else if (state.checkoutMode === 'transporte') {
      entrega = `🚛 Transporte a elección\n• Nombre: ${f.nombre}\n• DNI: ${f.dni}\n• Transporte: ${f.transporte}\n• Dir. depósito: ${f.direccion_transporte}\n• Destino: ${f.destino}\n• Tel: ${f.telefono}`;
    }

    const shipLine = ship.free
      ? '🎁 Envío bonificado'
      : (ship.cost > 0 ? `Envío: ${fmt(ship.cost)}` : 'Envío: a coordinar (flete a cargo del cliente)');

    const parts = [
      `*Hola Provenzano! Quiero hacer este pedido* 🛒`,
      ``,
      lines,
      ``,
      `Subtotal: ${fmt(subtotal)}`,
      shipLine,
      `*Total estimado: ${fmt(total)}*`,
      ``,
      entrega,
      ``,
      `Fecha: ${today}`,
    ];
    if (f.nota && f.nota.trim()) parts.push(`Nota: ${f.nota}`);
    return parts.join('\n');
  }

  function sendWhatsApp() {
    const msg = buildWhatsAppMessage();
    const url = `https://wa.me/${CFG.whatsapp}?text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank', 'noopener');
    showToast('Abriendo WhatsApp…');
    closeCheckout();
    state.cart = [];
    renderCart();
    updateCartBadge();
  }

  /* ── Toast ───────────────────────────────────────────────── */
  let toastTimer;
  function showToast(msg) {
    if (!$toast) return;
    $toast.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
      ${escHtml(msg)}`;
    $toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => $toast.classList.remove('is-visible'), 2200);
  }

  /* ── Skeletons ───────────────────────────────────────────── */
  function renderSkeletons(n) {
    if (!$grid) return;
    $grid.innerHTML = Array.from({ length: n }).map(() => `
      <article class="pv-pcard is-skeleton">
        <div class="pv-pcard__img"><div class="pv-skeleton" style="width:100%;padding-top:100%"></div></div>
        <div class="pv-pcard__body">
          <div class="pv-skeleton" style="height:10px;width:40%;margin-bottom:8px"></div>
          <div class="pv-skeleton" style="height:14px;width:80%;margin-bottom:4px"></div>
          <div class="pv-skeleton" style="height:14px;width:60%"></div>
        </div>
        <div class="pv-pcard__bottom" style="border-top:1px solid var(--border-1);padding-top:8px;margin-top:auto">
          <div class="pv-skeleton" style="height:32px;width:70px"></div>
          <div class="pv-skeleton" style="height:36px;width:36px;border-radius:10px"></div>
        </div>
      </article>`).join('');
  }

  /* ── Icons ───────────────────────────────────────────────── */
  function iconPlus() {
    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>`;
  }
  function iconMinus() {
    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>`;
  }
  function iconTrash() {
    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>`;
  }
  function iconArrowRight() {
    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" style="width:18px;height:18px"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>`;
  }
  function modeIcon(name) {
    const icons = {
      store: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>`,
      truck: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>`,
      package: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>`,
    };
    return icons[name] || icons.package;
  }

  function escHtml(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ── Header scroll ───────────────────────────────────────── */
  function initHeaderScroll() {
    const $header = document.querySelector('.pv-header');
    if (!$header) return;
    const onScroll = () => $header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Public API ──────────────────────────────────────────── */
  window.PV_CATALOG = {
    setQty: setCartQty,
    removeItem: removeFromCart,
    openCheckout,
    setCheckoutMode(id) {
      state.checkoutMode = id;
      renderCheckout();
    },
    setCheckoutSubmode(id) {
      state.checkoutSubmode = id;
      renderCheckout();
    },
    sendWhatsApp,
  };

  /* ── Init ────────────────────────────────────────────────── */
  async function init() {
    $grid        = el('pv-grid');
    $filterBar   = el('pv-filter-bar');
    $countRow    = el('pv-count');
    $cartBadge   = el('pv-cart-badge');
    $cartOverlay = el('pv-cart-overlay');
    $cartDrawer  = el('pv-cart');
    $cartBody    = el('pv-cart-body');
    $cartFoot    = el('pv-cart-foot');
    $coOverlay   = el('pv-co-overlay');
    $coModeGrid  = el('pv-co-modes');
    $coFields    = el('pv-co-fields');
    $toast       = el('pv-toast');

    initHeaderScroll();

    const $cartBtn = el('pv-header-cart');
    if ($cartBtn) $cartBtn.addEventListener('click', openCart);

    if ($cartOverlay) $cartOverlay.addEventListener('click', closeCart);
    const $cartCloseBtn = el('pv-cart-close');
    if ($cartCloseBtn) $cartCloseBtn.addEventListener('click', closeCart);

    if ($coOverlay) {
      $coOverlay.addEventListener('click', (e) => {
        if (e.target === $coOverlay) closeCheckout();
      });
    }
    const $coCloseBtn = el('pv-co-close');
    if ($coCloseBtn) $coCloseBtn.addEventListener('click', closeCheckout);

    const $sendBtn = el('pv-co-send');
    if ($sendBtn) $sendBtn.addEventListener('click', sendWhatsApp);

    const $fab = el('pv-wa-fab');
    if ($fab) {
      $fab.addEventListener('click', (e) => {
        e.preventDefault();
        if (state.cart.length > 0) {
          openCheckout();
        } else {
          window.open(`https://wa.me/${CFG.whatsapp}`, '_blank', 'noopener');
        }
      });
    }

    const $search = el('pv-search-input');
    if ($search) {
      $search.addEventListener('input', () => {
        state.searchQuery = $search.value;
        applyFilters();
      });
    }

    renderCart();
    renderSkeletons(12);

    try {
      const raw = await fetchAllProducts();
      state.products = raw;

      const typeCounts = {};
      raw.forEach(p => {
        const t = (p.product_type || '').toLowerCase().trim();
        if (t) typeCounts[t] = (typeCounts[t] || 0) + 1;
      });
      const types = Object.entries(typeCounts)
        .sort((a, b) => b[1] - a[1])
        .map(([t]) => t);

      renderFilters(types);
      renderProducts(raw);

      if ($countRow) $countRow.textContent = `${raw.length} producto${raw.length !== 1 ? 's' : ''} disponibles`;

    } catch (err) {
      console.error('[PV_CATALOG] Error loading products:', err);
      if ($grid) {
        $grid.innerHTML = `
          <div class="pv-no-results">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            <p>No se pudo cargar el catálogo</p>
            <small>Recargá la página o consultá por WhatsApp.</small>
          </div>`;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();